// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eE","newsTag":"eE","dafalut":"eF","qishou":"eG","shangjia":"eH","shehui":"eI","caiwu":"eJ","piyao":"eK","suanfa":"eL","keji":"eM","lingshou":"eN","gongzuo":"eO"};